export const TITLE = 'title';
export const DESCRIPTION = 'description';
